<template>
  <div class="w_100 profile-container" v-if="addresses">
    <div class="profile-head mb16">
      <main-title class="mt10"
        >{{ $t("profile.title") }} {{ accuracy }}</main-title
      >

      <main-logout />
    </div>

    <edit-form v-if="client" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import mainContainer from "@/components/base/mainContainer";
import mainTitle from "@/components/base/mainTitle";
import mainLogout from "@/components/base/mainLogout";

import editForm from "@/components/forms/profile/editProfile";

export default {
  name: "profile",
  components: {
    mainContainer,
    mainTitle,
    editForm,
    mainLogout,
  },
  computed: {
    ...mapGetters({
      client: "client/client",
      addresses: "address/addresses",
    }),
  },
  data() {
    return {
      accuracy: null,
    };
  },
  methods: {
    ...mapActions({
      fetch: "address/fetch",
    }),
  },
  async mounted() {
    var id, target, options;
    const vm = this;

    await this.fetch();
    this.$log("menu_profile");
  },
};
</script>

<style lang="scss">
.main-logout {
  margin-left: auto;
  display: inline-block;
  // position: absolute;
  // bottom: 0;
  // left: 0;
  // right: 0;
  // padding: 30px;
  // border-top: 1px solid #00000008;

  button {
    background-color: transparent;
    border: none;
    cursor: pointer;
  }
}

.profile {
  &-head {
    display: flex;
    align-items: center;
    width: 665px;
  }
}
.profile-container {
  width: calc(100vw - 310px);
}

@media (max-width: 1024px) {
  .profile {
    &-head {
      width: 100%;
      max-width: 665px;
    }
  }
}

@media (max-width: 768px) {
  .profile {
    &-head {
      width: 100%;
    }
  }

  .profile-container {
    width: calc(100vw - 42px);
  }
}

@media (max-width: 568px) {
  .profile-container {
    width: calc(100vw - 22px);
  }
}
</style>
